export default __webpack_public_path__ + "static/media/bkg--home-1.5f93eb7f.jpg";